/**
 * Shared utilities for converting between measurement units (M2 ↔ sheets)
 * Used by ProductSelector (for conversion during selection)
 * and useQuoteCalculations (for validation after adding)
 */

interface MeasurementCalculation {
  sheetsNeeded: number;
  m2PerSheet: number;
  requestedM2: number;
  calculatedM2: number;
}

/**
 * Calculates sheets and M2 from a requested M2 amount
 * Rounds sheets up (ceiling)
 */
export const calculateSheetsFromM2 = (
  widthCm: number,
  lengthCm: number,
  requestedM2: number
): MeasurementCalculation => {
  const m2PerSheet = (widthCm / 100) * (lengthCm / 100);
  const sheetsNeeded = Math.ceil(requestedM2 / m2PerSheet);
  const calculatedM2 = Math.round(sheetsNeeded * m2PerSheet * 100) / 100;

  return {
    sheetsNeeded,
    m2PerSheet,
    requestedM2,
    calculatedM2,
  };
};

/**
 * Calculates M2 from a number of sheets
 */
export const calculateM2FromSheets = (
  widthCm: number,
  lengthCm: number,
  sheets: number
): MeasurementCalculation => {
  const m2PerSheet = (widthCm / 100) * (lengthCm / 100);
  const calculatedM2 = Math.round(sheets * m2PerSheet * 100) / 100;

  return {
    sheetsNeeded: sheets,
    m2PerSheet,
    requestedM2: calculatedM2,
    calculatedM2,
  };
};
